import { render, staticRenderFns } from "./HistoryPacient.vue?vue&type=template&id=8af3a64e"
import script from "./HistoryPacient.vue?vue&type=script&lang=js"
export * from "./HistoryPacient.vue?vue&type=script&lang=js"
import style0 from "./HistoryPacient.vue?vue&type=style&index=0&id=8af3a64e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports